import { Category } from '../../domain/models';

export class AircraftCategory extends Category {
  selected = false;
}
